/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Status_SubmittedInputs */



/**
* | output |
* | --- |
* | "Submitted" |
*
* @param {Embed_Captions_Status_SubmittedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_status_submitted = /** @type {((inputs?: Embed_Captions_Status_SubmittedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Status_SubmittedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Soumis")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eingereicht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inviato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поданный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已提交")
	if (locale === "ja") return /** @type {LocalizedString} */ ("提出済み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रस्तुत किया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enviado")
	return /** @type {LocalizedString} */ ("Submitted")
});